<div class="grid-container">
  <div class="grid-row">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <legend class="usa-legend usa-legend--medium">FRT Rates Query Report</legend>
    </div>
    <form id="filterGroup" [formGroup]="filterGroup">
      @if (filterGroup.hasError('dateRange')) {
        <div class="grid-row">
          <div class="usa-alert usa-alert--error usa-alert--slim">
            <div class="usa-alert__body">
              <p class="usa-alert__text">
                Invalid dates. From date should be earlier than to date.
              </p>
            </div>
          </div>
        </div>
      }
      <div class="grid-row grid-gap">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          <label for="frt_search_by_date_from" class="usa-label">From: </label>
          <input type="text" id="frt_search_by_date_from" class="usa-input maxw-full"
            placeholder="mm/dd/yyyy" bsDatepicker formControlName="fromDate" (bsValueChange)="filterFromDateChange($event)"
            [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false }">
          </div>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
            <label for="frt_search_by_date_to" class="usa-label">To: </label>
            <input type="text" id="frt_search_by_date_to" class="usa-input maxw-full"
              placeholder="mm/dd/yyyy" bsDatepicker formControlName="toDate" (bsValueChange)="filterToDateChange($event)"
              [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY', containerClass: 'theme-dark-blue', showWeekNumbers: false }">
            </div>
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
              <label  class="usa-label">&nbsp;  </label>
              <button type="button" class="usa-button" [disabled]="!filterGroup.valid" (click)="searchByFilter()"> Search </button>
            </div>
          </div>
        </form>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-4">
          <span>
            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
              <use xlink:href="/assets/uswds/img/sprite.svg#file_download"></use>
            </svg>
            Right click on the report and select the appropriate options to export.
          </span>
        </div>

        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
          <ag-grid-angular class="ag-theme-alpine" [rowData]="results" [domLayout]="domLayout" [pagination]="true" [paginationPageSize]="itemsPerPage" [columnDefs]="messageColumnDefs">
          </ag-grid-angular>
          <div id="myChart" class="ag-theme-alpine my-chart"></div>
        </div>
      </div>
    </div>